// extracted by css-extract-rspack-plugin
export default {"ratingChooser":"rating-chooser--A8FHsiiyzo8WhOVR","ratingChooserRadio":"rating-chooser-radio--ETtXrMIc3QxpRWIL","ratingChooserItem":"rating-chooser-item--xqdDVkF8PZoGQCoc"};